import { createProjectInputSchema, type CreateProjectInput, type ProjectDomain } from '@mybusinessmate/schema';

export interface ProjectFormValues {
  name: string;
  domain: ProjectDomain;
  description: string;
  /** `YYYY-MM-DD`, or '' when not set. */
  startDate: string;
  targetEndDate: string;
}

export const emptyProjectForm: ProjectFormValues = {
  name: '',
  domain: 'Website',
  description: '',
  startDate: '',
  targetEndDate: '',
};

export type ProjectFormErrors = Partial<Record<keyof ProjectFormValues, string>>;

export type ProjectFormResult = { ok: true; body: CreateProjectInput } | { ok: false; errors: ProjectFormErrors };

/** Validates with the schema the API uses, so the drawer can never disagree with the server about what is valid. */
export function toProjectRequest(values: ProjectFormValues, businessId: string): ProjectFormResult {
  const body: CreateProjectInput = {
    businessId,
    name: values.name,
    domain: values.domain,
    description: values.description,
    ...(values.startDate ? { startDate: values.startDate } : {}),
    ...(values.targetEndDate ? { targetEndDate: values.targetEndDate } : {}),
  };
  const parsed = createProjectInputSchema.safeParse(body);
  if (parsed.success) return { ok: true, body };

  const errors: ProjectFormErrors = {};
  for (const issue of parsed.error.issues) {
    const key = issue.path[0] as keyof ProjectFormValues | undefined;
    if (key && key in emptyProjectForm && !errors[key]) errors[key] = issue.message;
  }
  return { ok: false, errors };
}
